import tw, { styled } from 'twin.macro'

export const StarsRoot = styled.div`
    ${tw`flex`}
`
